import React from 'react'
import QuestionnaireQuestion from "./QuestionnaireQuestion"

export default class extends React.Component {
  static defaultProps = {
    name: 'No area name',
    semantic_area: 'no_semantic_area',
    questions: [],
    mandatory: false,
    locale: 'fi',
    plainText: false,
    answerListener: () => null,
  };

  state = {};

  render() {

    const questionsToShow = this.props.plainText === true ?
      this.props.questions.filter((question) =>
        question.exclude_in_plain_language !== true
      ) :
      this.props.questions

    return (
      <div className={(this.props.mandatory ? 'mandatory' : '') + " category-container"}
        data-semantic_area={this.props.semantic_area}>
        {
          questionsToShow.map((question, i) =>
            <QuestionnaireQuestion key={question.id} locale={this.props.locale} odd_row={i % 2 === 0}
              onAnswer={this.props.answerListener} mandatory={this.props.mandatory}
              plainText={this.props.plainText}
              {...question}>
            </QuestionnaireQuestion>
          )
        }
      </div>
    )
  }
}